import AdSense from "react-adsense";
import { useRouteMatch } from "react-router-dom";
// import UUID from "../Utils/uuid";
import ErrorBoundary from "../Components/ErrorBoundaries";

const SideBar = () => {
  const { params } = useRouteMatch();
  const { problemUrl } = params;

  return (
    <ErrorBoundary>
      <AdSense.Google
        client="ca-pub-5281236737710443"
        slot="7255324941"
        style={{ display: "block" }}
        format="auto"
        responsive="true"
        key={`${problemUrl}`}
      />
    </ErrorBoundary>
  );
};

export default SideBar;
